<template>
  <FooterPageLayout v-model:selectedListItemIndexFromProps="selectedListItemIndex" :pageData="lawPageData">
    <div class="wd-my-6 <xs:wd-mx-5 <xs:wd-mb-9" v-html="$t('japan_term_content')" />
  </FooterPageLayout>
</template>

<script setup lang="ts">
import FooterPageLayout from '@/components/FooterPageLayout.vue'

definePageMeta({
  name: 'terms-law',
  middleware(to, _from) {
    const nuxtApp = useNuxtApp()
    if (nuxtApp.$i18n.locale.value !== 'ja') {
      return navigateTo(
        nuxtApp.$localePath({
          name: 'terms-consumer',
          query: to.query,
        })
      )
    }
  },
})

const nuxtApp = useNuxtApp()

const { $i18n } = nuxtApp
const route = useRoute()

const selectedListItemIndex = ref(0)

const lawPageData = computed(() => ({
  title: $i18n.t('footer_japan_term'),
  list: [
    {
      text: $i18n.t('footer_user_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-consumer',
        query: route.query,
      }),
    },
    {
      text: $i18n.t('footer_private_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-privacy',
        query: route.query,
      }),
    },
    {
      text: $i18n.t('footer_refund_policy'),
      localePath: nuxtApp.$localePath({
        name: 'terms-refund',
        query: route.query,
      }),
    },
    {
      text: $i18n.t('footer_japan_term'),
      localePath: nuxtApp.$localePath({
        name: 'terms-law',
        query: route.query,
      }),
    },
  ],
}))

onMounted(() => {
  selectedListItemIndex.value = lawPageData.value.list.length - 1
})
</script>

<style lang="scss" scoped></style>
